import { empty, of } from 'rxjs'
import * as R from 'ramda'
import { delayWhen, filter, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { VIEWPORTS } from 'constants/screenSize'
import { PRODUCT_TYPE, SALE_TYPE } from 'constants/resources'
import { getNewMediaQueries } from 'domain/screenSize'
import { isPackageOutOfStock, packageBelongsToProduct } from 'domain/packages'
import * as Actions from 'store/actions/index.ts'
import {
  getActivePackage,
  getCurrentProduct,
  getFiltersFromQuery,
  getFirstAvailablePackage,
  getIsFiltersRequestPending,
  getIsProductFetched,
  getIsResourceFetched,
  getSaleResource
} from '../selectors'

const isProductFetchedAction = action => (
  action.payload.type === PRODUCT_TYPE
)

const isSaleFetchedAction = (action) => ( // (action: ResourceFetchedAction): boolean
  action.payload.type === SALE_TYPE
)

export default (actions$, state$) => actions$.pipe(
  ofType(
    Actions.stock.PRODUCT_STOCK_FETCHED,
    Actions.package.AUTO_SELECT_PACKAGE
  ),
  delayWhen(() => { // find a better way than 2 delayWhen
    const state = state$.value

    if (
      getIsResourceFetched(state) &&
      (getSaleResource(state) || getCurrentProduct(state)) &&
      getIsProductFetched(state)
    ) {
      return of({})
    }

    return actions$.pipe(
      ofType(Actions.resources.RESOURCE_FETCHED),
      filter(a => isSaleFetchedAction(a) || isProductFetchedAction(a)),
      delayWhen(() => {
        const state = state$.value

        if (
          getIsResourceFetched(state) &&
          getSaleResource(state) &&
          getIsProductFetched(state)
        ) {
          return of({})
        }

        return actions$.pipe(
          ofType(Actions.resources.RESOURCE_FETCHED),
          filter(a => isSaleFetchedAction(a) || isProductFetchedAction(a))
        )
      })
    )
  }),
  delayWhen(() => {
    const state = state$.value

    if (R.isEmpty(getFiltersFromQuery(state)) || !getIsFiltersRequestPending(state)) {
      return of({})
    }

    return actions$.pipe(
      ofType(Actions.filters.FILTERS_FETCHED)
    )
  }),
  switchMap(() => {
    const state = state$.value
    const currentProduct = getCurrentProduct(state)

    if (!currentProduct) { return empty() }

    const screenSize = getNewMediaQueries(VIEWPORTS)
    const firstAvailablePackage = (screenSize.large || currentProduct.resources.length === 1) ? getFirstAvailablePackage(state) : null
    const activePackage = getActivePackage(state)

    const isActivePackageInvalid = (
      !activePackage ||
      isPackageOutOfStock(activePackage) ||
      !packageBelongsToProduct(activePackage, currentProduct)
    )

    const productHasPackages = currentProduct && currentProduct.resources.length > 0

    if (isActivePackageInvalid) {
      if (productHasPackages && firstAvailablePackage) {
        return of(Actions.package.onSelectPackage(firstAvailablePackage.key))
      }
      return of(Actions.package.onSelectPackage(null))
    }

    return empty()
  })
)
